import { useQuery } from '@tanstack/react-query';
import type { ActiveMembership } from '@/lib/types/auth.types';
import { profileRegistry } from '../registry';

/**
 * Fetches the active entity's typed profile through the registry (ADR FE-1):
 * `entity.type` selects the module, which owns the query key and the typed api
 * client. No role branching, no direct axios in components.
 *
 * @param entity - the active membership (`{ entityId, entityType, ... }`)
 * @param options.enabled - skip the fetch (e.g. while a module is coming-soon)
 */
export function useEntityProfile(
  entity: ActiveMembership,
  options: { enabled?: boolean } = {},
) {
  const mod = profileRegistry[entity.entityType];
  return useQuery({
    queryKey: mod.queryKey(entity.entityId),
    queryFn: () => mod.fetch(entity.entityId),
    enabled: options.enabled ?? true,
  });
}
